import React, { PropTypes } from 'react';

const Dropdown = ({ onChange, title, values }) => (
  <div className="filter">
    <label htmlFor="year-dropdow">{title}</label>
    <div className="select-wrapper">
      <select onChange={onChange} id="year-dropdow">
        {values.map((value, index) => (
          <option key={index} value={value}>
            {value}
          </option>
        ))}
      </select>
    </div>
  </div>
);

Dropdown.propTypes = {
  onChange: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  values: PropTypes.arrayOf(PropTypes.string).isRequired
};

export default Dropdown;



// WEBPACK FOOTER //
// ./src/pages/press/components/Dropdown/Dropdown.js